import { render } from "./CalendarPage.vue?vue&type=template&id=a32c001e&scoped=true"
import script from "./CalendarPage.vue?vue&type=script&lang=js"
export * from "./CalendarPage.vue?vue&type=script&lang=js"

import "./CalendarPage.vue?vue&type=style&index=0&id=a32c001e&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a32c001e"]])

export default __exports__